import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
// import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
// import Anchor from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ArrowForward, Visibility, VisibilityOff } from '@material-ui/icons';
import TextField from '@components/TextField';
// import googleIcon from '../Register/google-icon-24.svg';
// import { GoogleButton } from '../Register/Register.styles';
// import { useFirebase } from 'react-redux-firebase';
import { validEmail, required } from '@utils/form';
import useStyles, { LoadingIcon } from './Login.styles';

function LoginForm(props) {
    const classes = useStyles();
    // const firebase = useFirebase();
    const { handleSubmit, pristine, submitting, loading } = props;
    const [showPassword, setShowPassword] = React.useState(false);
    // const loginWithGoogle = () => {
    //     return firebase
    //         .login({ provider: 'google', type: 'popup', scopes: ['email, profile'] })
    //         .then((response) => {
    //             firebase
    //                 .auth()
    //                 .currentUser.updateProfile({
    //                     displayName: response.additionalUserInfo.displayName,
    //                     photoURL: response.additionalUserInfo.photoURL,
    //                 })
    //                 .then(() => {
    //                     firebase.updateProfile({
    //                         scopes: response.additionalUserInfo.profile.granted_scopes,
    //                         firstname: response.additionalUserInfo.profile.given_name,
    //                         lastname: response.additionalUserInfo.profile.family_name,
    //                         initials:
    //                             response.additionalUserInfo.profile.given_name[0] +
    //                             response.additionalUserInfo.profile.family_name[0],
    //                     });
    //                 })
    //                 .then(() => {
    //                     firebase
    //                         .auth()
    //                         .currentUser.getIdTokenResult()
    //                         .then((res) => {
    //                             console.warn(res.claims);
    //                         })
    //                         .catch((err) => {
    //                             console.warn(err);
    //                         });
    //                 });
    //         });
    // };
    return (
        <Card
            component="form"
            elevation={0}
            square
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off">
            <CardHeader
                className={classes.cardHeader}
                title={<img src="/assets/coloured-logo.svg" alt="Deal Depot" />}
            />
            <CardContent className={classes.cardContent}>
                <Typography
                    className={classes.cardContentTitle}
                    align="center"
                    component="h5"
                    variant="h5">
                    Log in to DealDepot
                </Typography>
                <Typography
                    className={classes.cardContentSubTitle}
                    align="center"
                    component="p"
                    variant="h6">
                    Enter your details below
                </Typography>
                <Field
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Your email"
                    name="email"
                    autoComplete="off"
                    component={TextField}
                    validate={[validEmail, required]}
                />
                <Field
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="off"
                    component={TextField}
                    validate={[required]}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    type="submit"
                    fullWidth
                    size="large"
                    disabled={pristine || submitting || loading}
                    endIcon={loading ? <LoadingIcon size={25} /> : <ArrowForward />}
                    variant="contained"
                    color="secondary"
                    className={classes.submit}>
                    {loading ? 'Loading' : 'Log in'}
                </Button>
                {/* <GoogleButton
                    type="button"
                    fullWidth
                    onClick={loginWithGoogle}
                    size="large"
                    startIcon={<img src={googleIcon} alt="icon" />}
                    variant="contained">
                    SIGN IN WITH GOOGLE
                </GoogleButton> */}
                {/* <Grid container>
                    <Grid item xs>
                        <Anchor
                            component={Link}
                            // onClick={firebase.auth().resetPassword(email)}
                            // to="/forgot-password"
                            variant="body2"
                            className={classes.link}>
                            Forgot password?
                        </Anchor>
                    </Grid>
                </Grid> */}
            </CardContent>
        </Card>
    );
}

LoginForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

const withForm = reduxForm(
    {
        form: 'LOGIN_FORM',
    },
    LoginForm,
);

export default compose(withForm)(LoginForm);
